module.exports = __webpack_public_path__ + "static/img/CHUCKS.6656e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/CHUCKS.png
// module id = B77M
// module chunks = 0